// ============================================================
// TIP NA DÁREK — popup formulář na detailu produktu
// Vedle tlačítka do košíku přidá link "Poslat jako tip na dárek!",
// který otevře overlay se Shoptet web-formem [w-form-694M9].
// Do sekce "Specifikace dárku" JS naklonuje variantní selecty produktu
// (předvyplněné z detailu) a jejich hodnoty zapíše do skrytých polí:
//   .chosen-variants — text variant (jen když jsou všechny zvolené)
//   .product-url     — URL produktu (vždy)
// Web-form addon: wtFormsInstance.reinit() vykreslí shortcode, po
// vykreslení vystřelí event wtFormLoaded.
// ============================================================

$(document).ready(function () {
    if ($(".type-detail").length === 0) {
        return;
    }

    const config = getShopDataLayer().giftTip;

    // Trigger link vedle tlačítka do košíku — bez textu z datalayeru se nevykreslí
    if (config.triggerButtonText && $(".gift-tip-trigger").length === 0) {
        $("<span class='gift-tip-trigger'>" + config.triggerButtonText + "</span>").appendTo(".p-add-to-cart-wrapper");
    }

    $(document).on("click", ".gift-tip-trigger", function () {
        openGiftTip(config);
    });

    // Zavření overlaye
    $(document).on("click", ".gift-tip-window .clickable-part, .gift-tip-window .close-tooltip", function () {
        $(".gift-tip-window").fadeOut(300);
    });

    // Po vykreslení web-formu naplň varianty a skrytá pole
    document.addEventListener("wtFormLoaded", function () {
        buildGiftVariants(config);
    });
});

// ============================================================
// Postaví / otevře overlay s formulářem
// ============================================================

function openGiftTip(config) {
    const title = config.popupTitle || "";
    const closeLabel = getShopDataLayer().buttons.close || "";
    // Fallback na CZ formulář drží popup funkční se starým datalayerem na FTP,
    // EN mutace potřebuje vlastní web-form přes giftTip.formShortcode
    const formShortcode = config.formShortcode || "[w-form-694M9]";

    if ($(".gift-tip-window").length === 0) {
        $(
            "<div class='mytooltip-window gift-tip-window' data='gift-tip' style='display: none;'>" +
            "<div class='clickable-part'></div>" +
            "<div class='gift-tip__inner'>" +
            "<div class='gift-tip__header'>" +
            "<span class='gift-tip__title'>" + title + "</span>" +
            "<div class='close-tooltip' aria-label='" + closeLabel + "'></div>" +
            "</div>" +
            "<div class='gift-tip__body'>" + formShortcode + "</div>" +
            "</div>" +
            "</div>"
        ).appendTo(".overall-wrapper");

        if (typeof wtFormsInstance !== "undefined" && typeof wtFormsInstance.reinit === "function") {
            wtFormsInstance.reinit();
        }

        // Blokace odeslání bez zvolených variant — capture fáze, aby validace
        // proběhla dřív než formeo submit handler na buttonu
        document.querySelector(".gift-tip-window").addEventListener("click", function (e) {
            if (!e.target.closest(".f-btn-group button")) {
                return;
            }
            if (!validateGiftVariants(config)) {
                e.preventDefault();
                e.stopImmediatePropagation();
            }
        }, true);
    } else {
        // Refresh variant — uživatel mohl mezitím změnit výběr na detailu
        buildGiftVariants(config);
    }

    $(".gift-tip-window").fadeIn(300);
}

// ============================================================
// Naklonuje variantní selecty produktu do "Specifikace dárku"
// ============================================================

function buildGiftVariants(config) {
    const $body = $(".gift-tip-window .gift-tip__body");
    if ($body.length === 0 || $body.find(".chosen-variants").length === 0) {
        return;
    }

    const $column = $body.find(".formeo-column").first();
    const $specHeading = $column.find("h2").eq(1);

    // Idempotence — odstraň předchozí klon
    $column.find(".gift-tip__variants").remove();

    const $variants = $("<div class='gift-tip__variants'></div>");

    $(".p-variants-block .variant-list").each(function () {
        const $select = $(this).find("select[id^='parameter-id-']");
        if ($select.length === 0) {
            return;
        }

        const paramId = $select.attr("data-parameter-id");
        const paramName = $select.attr("data-parameter-name") || $(this).find("th").text().trim();
        const currentValue = $select.val();

        const $field = $("<div class='gift-tip__field' data-parameter-id='" + paramId + "'></div>");
        $field.append("<label class='gift-tip__label'>" + paramName + "</label>");

        const $clone = $("<select class='gift-tip__select'></select>");
        $select.find("option").each(function () {
            const selected = $(this).attr("value") === currentValue ? " selected" : "";
            $clone.append("<option value='" + $(this).attr("value") + "'" + selected + ">" + $(this).text().trim() + "</option>");
        });

        $field.append($clone);
        $variants.append($field);
    });

    // Produkt bez variant — skryj sekci "Specifikace dárku"
    if ($variants.children().length === 0) {
        $specHeading.hide();
    } else {
        $specHeading.show();
        $variants.insertAfter($specHeading);
    }

    recomputeGiftFields(config);

    $body.off("change.giftTip").on("change.giftTip", ".gift-tip__select", function () {
        recomputeGiftFields(config);

        // Vyber varianty → odeber zvýraznění chyby
        if ($(this).val()) {
            $(this).closest(".gift-tip__field").removeClass("gift-tip__field--error");
        }
        if ($body.find(".gift-tip__field--error").length === 0) {
            $body.find(".gift-tip__variants-error").remove();
        }
    });
}

// ============================================================
// Validace variant — true když produkt nemá varianty nebo jsou všechny zvolené
// ============================================================

function validateGiftVariants(config) {
    const $body = $(".gift-tip-window .gift-tip__body");
    const $fields = $body.find(".gift-tip__field");

    // Produkt bez variant — neblokuj
    if ($fields.length === 0) {
        return true;
    }

    let valid = true;
    $fields.each(function () {
        if ($(this).find(".gift-tip__select").val()) {
            $(this).removeClass("gift-tip__field--error");
        } else {
            $(this).addClass("gift-tip__field--error");
            valid = false;
        }
    });

    $body.find(".gift-tip__variants-error").remove();
    if (!valid && config.variantsErrorText) {
        $("<div class='gift-tip__variants-error'>" + config.variantsErrorText + "</div>").insertAfter($body.find(".gift-tip__variants"));
    }

    return valid;
}

// ============================================================
// Zapíše stav variant do .chosen-variants a URL do .product-url
// ============================================================

function recomputeGiftFields(config) {
    const $body = $(".gift-tip-window .gift-tip__body");
    const prefix = config.variantsLabelPrefix || "";

    // URL produktu — vždy
    $body.find(".product-url").val(window.location.href);

    const $fields = $body.find(".gift-tip__field");

    // Produkt bez variant — nech .chosen-variants prázdné
    if ($fields.length === 0) {
        $body.find(".chosen-variants").val("");
        return;
    }

    let allChosen = true;
    const lines = [];

    $fields.each(function () {
        const $select = $(this).find(".gift-tip__select");
        const value = $select.val();

        if (!value) {
            allChosen = false;
            return;
        }

        const label = $(this).find(".gift-tip__label").text().trim();
        lines.push(label + ": " + $select.find("option:selected").text().trim());
    });

    // Vyplň jen když jsou všechny varianty zvolené, jinak prázdné
    $body.find(".chosen-variants").val(allChosen ? (prefix ? prefix + "\n" : "") + lines.join("\n") : "");
}
